import Swal from "sweetalert2";
import { IEvento } from "../interfaces/IEvento";
import api from "./Api";

class EventoService {
    async obterTodos(funcaoSucesso?: (data: IEvento[]) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IEvento[]>('Evento');

            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async obterPorId(id: number, funcaoSucesso?: (data: IEvento) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.get<IEvento>(`Evento/${id}`);
        
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async adicionar(evento: IEvento, funcaoSucesso?: (data: IEvento) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.post<IEvento>('Evento', evento);
        
            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async alterar(evento: IEvento, funcaoSucesso?: (data: IEvento) => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            const { data: result } = await api.put(`Evento/${evento.id}`, evento);

            funcaoSucesso && funcaoSucesso(result);
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }

    async excluir(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
        try {
            await api.delete(`Evento/${id}`);
        
            funcaoSucesso && funcaoSucesso();
        
            textoPopupSucesso && Swal.fire({
                text: textoPopupSucesso,
                timer: 3000,
                icon: 'success',
                showConfirmButton: false
            });
            
            return true;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        
            return false;
        }
    }
}

export default new EventoService();